<template>

  <section

    id="dashboard-ecommerce"

    v-if="$can('read','recruiter_report') || $can('read','report')"

  >

    <div>

      <div class="text-center"><h3>Recruiter Work Tracker</h3></div>



      <b-card>

        <div>

          <b-row>

            <b-col md="4" xl="4" xs="4" class="mb-1">

              <b-form-group

                label="Start Date"

                label-for="start-date"

              >

                <flat-pickr

                  v-model="startDate"

                  class="form-control"

                  :config="{ enableTime: false, dateFormat: 'Y-m-d' }"

                />

                <small v-if="!startDate" class="text-danger">Start Date is Mandatory</small>

              </b-form-group>

            </b-col>

            <b-col md="4" xl="4" xs="4" class="mb-1">

              <b-form-group

                label="End Date"

                label-for="end-date"

              >

                <flat-pickr

                  v-model="endDate"

                  class="form-control"

                  :config="{ enableTime: false, dateFormat: 'Y-m-d' }"

                />

                <small v-if="!endDate" class="text-danger">End Date is Mandatory</small>

              </b-form-group>

            </b-col>

            <b-col md="4" xl="4" xs="4" class="mb-1">

              <b-form-group label="" label-for="">

                <b-button

                  variant="outline-primary"

                  id="submit"

                  type="submit"

                  style="margin-top: 20px"

                  @click="getReport"

                >

                  Get Report

                </b-button>

                <b-button

                  v-if="canDownloadReport"

                  variant="outline-secondary"

                  style="margin-top: 20px; margin-left: 8px"

                  :disabled="!isDownloadReady"

                  v-b-tooltip.hover

                  :title="isDownloadReady ? 'Download report as Excel' : 'Run Get Report first'"

                  @click="downloadReport"

                >

                  Download

                </b-button>

              </b-form-group>

            </b-col>

          </b-row>



          <div v-if="loading">

            <div class="text-center">

              <b-spinner variant="primary" label="Text Centered" />

            </div>

          </div>



          <div v-if="!loading && compiledData && compiledData.length">

            <span v-if="reportStatus" class="text-danger">{{ reportStatus }}</span>

            <div

              id="work-tracker"

              class="work-tracker-block"

              v-for="d in compiledData"

              :key="d.am_name"

            >

              <div class="team-header">{{ d.am_name }}</div>

              <div class="table-scroll">

                <table class="work-tracker-table">

                  <thead>

                    <tr>

                      <th class="col-recruiter">Recruiter</th>

                      <th class="col-client">Client</th>

                      <th class="col-position">Position Name</th>

                      <th class="col-num">Total Contact</th>

                      <th class="col-num">Call back</th>

                      <th class="col-num">Not Interested</th>

                      <th class="col-num">Not Relevant</th>

                      <th class="col-num">Profile Shared</th>

                      <th class="col-num">Success %</th>

                      <th class="col-total">Total</th>

                    </tr>

                  </thead>

                  <tbody>

                    <template v-for="(r, rIndex) in d.data">

                      <tr

                        v-for="(t, tIndex) in trackerRows(r)"

                        :key="`${rIndex}-${tIndex}`"

                      >

                        <td

                          v-if="tIndex === 0"

                          class="col-recruiter text-center"

                          :rowspan="trackerRowCount(r)"

                        >

                          {{ r.rec_name }}

                        </td>

                        <td class="col-client text-left">{{ t.Client || '—' }}</td>

                        <td class="col-position text-left">{{ t.PositionName || '—' }}</td>

                        <td class="col-num">{{ cellValue(t.TotalContact) }}</td>

                        <td class="col-num">{{ cellValue(t.CallBack) }}</td>

                        <td class="col-num">{{ cellValue(t.NotInterested) }}</td>

                        <td class="col-num">{{ cellValue(t.NotRelevant) }}</td>

                        <td class="col-num">{{ cellValue(t.ProfileShared) }}</td>

                        <td class="col-num">{{ rowSuccess(t) }}%</td>

                        <td

                          v-if="tIndex === 0"

                          class="col-total text-center"

                          :rowspan="trackerRowCount(r)"

                        >

                          {{ recruiterTotal(r) }}

                        </td>

                      </tr>

                    </template>

                  </tbody>

                  <tfoot>

                    <tr>

                      <td colspan="3" class="footer-label">Total</td>

                      <td class="col-num">{{ cellValue(d.TC) }}</td>

                      <td class="col-num">{{ cellValue(d.CB) }}</td>

                      <td class="col-num">{{ cellValue(d.NI) }}</td>

                      <td class="col-num">{{ cellValue(d.NR) }}</td>

                      <td class="col-num">{{ cellValue(d.PS) }}</td>

                      <td class="col-num">{{ teamSuccess(d) }}%</td>

                      <td class="col-total">{{ teamGrandTotal(d) }}</td>

                    </tr>

                  </tfoot>

                </table>

              </div>

            </div>

          </div>



          <div v-if="!loading && hasFetched && (!compiledData || !compiledData.length)">

            <span class="text-danger">{{ reportStatus }}</span>

          </div>

        </div>

      </b-card>

    </div>

  </section>

</template>



<script>

import { BRow, BCol, BCard, BButton, BFormGroup, BSpinner, VBTooltip } from 'bootstrap-vue'

import flatPickr from 'vue-flatpickr-component'

import moment from 'moment'

import reportService from '@/services/report-service'

import {

  buildReportFilename,

  downloadBase64Excel,

  exportRowsToExcel,

} from '@/utils/report-download'



export default {

  components: {

    BRow,

    BCol,

    BCard,

    BButton,

    BFormGroup,

    BSpinner,

    flatPickr,

  },

  directives: {

    'b-tooltip': VBTooltip,

  },

  data() {

    return {

      startDate: '',

      endDate: '',

      compiledData: [],

      loading: false,

      hasFetched: false,

      filename: '',

      reportStatus: '',

      downloadFile: '',

      userData: JSON.parse(localStorage.getItem('userData')),

    }

  },

  computed: {

    canDownloadReport() {

      return this.$can('download', 'recruiter_report')

        || this.$can('download', 'report')

        || this.$can('read', 'recruiter_report')

        || this.$can('read', 'report')

        || this.$can('manage', 'all')

    },

    isDownloadReady() {

      return this.hasFetched && (Boolean(this.downloadFile) || this.compiledData.length > 0)

    },

  },

  created() {

    const today = moment().locale('en')

    this.startDate = today.clone().startOf('week').add(1, 'days').format('YYYY-MM-DD')

    this.endDate = today.clone().endOf('week').format('YYYY-MM-DD')

  },

  methods: {

    cellValue(value) {

      return value != null && value !== '' ? value : 0

    },

    trackerRows(recruiter) {

      if (recruiter.tracker && recruiter.tracker.length > 0) {

        return recruiter.tracker

      }

      return [{}]

    },

    trackerRowCount(recruiter) {

      return this.trackerRows(recruiter).length

    },

    rowSuccess(row) {

      if (row.Success != null && row.Success !== '') {

        const parsed = parseFloat(String(row.Success).replace('%', ''))

        return Number.isNaN(parsed) ? '0.00' : parsed.toFixed(2)

      }

      const totalContact = parseInt(row.TotalContact, 10) || 0

      const profileShared = parseInt(row.ProfileShared, 10) || 0

      if (totalContact === 0) return '0.00'

      return ((profileShared * 100) / totalContact).toFixed(2)

    },

    teamSuccess(team) {

      if (team.S != null && team.S !== '') {

        const parsed = parseFloat(String(team.S).replace('%', ''))

        return Number.isNaN(parsed) ? '0.00' : parsed.toFixed(2)

      }

      const totalContact = parseInt(team.TC, 10) || 0

      const profileShared = parseInt(team.PS, 10) || 0

      if (totalContact === 0) return '0.00'

      return ((profileShared * 100) / totalContact).toFixed(2)

    },

    recruiterTotal(recruiter) {

      if (recruiter.total && recruiter.total.total != null) return recruiter.total.total

      if (recruiter.total != null) return recruiter.total

      return 0

    },

    teamGrandTotal(team) {

      if (!team.data || !team.data.length) {

        return team.PS != null ? team.PS : 0

      }

      return team.data.reduce((sum, recruiter) => {

        const total = this.recruiterTotal(recruiter)

        return sum + (parseInt(total, 10) || 0)

      }, 0)

    },

    getDownloadFilename() {

      return this.filename || buildReportFilename('Recruiter_Work_Tracker', this.startDate, this.endDate)

    },

    buildRecruiterExportRows() {

      const rows = []

      this.compiledData.forEach(team => {

        team.data.forEach(rec => {

          const total = this.recruiterTotal(rec)

          this.trackerRows(rec).forEach(t => {

            rows.push({

              'Team Lead': team.am_name,

              Recruiter: rec.rec_name,

              Client: t.Client ?? '',

              'Position Name': t.PositionName ?? '',

              'Total Contact': t.TotalContact ?? 0,

              'Call back': t.CallBack ?? 0,

              'Not Interested': t.NotInterested ?? 0,

              'Not Relevant': t.NotRelevant ?? 0,

              'Profile Shared': t.ProfileShared ?? 0,

              'Success %': this.rowSuccess(t),

              Total: total,

            })

          })

        })

        rows.push({

          'Team Lead': team.am_name,

          Recruiter: 'Total',

          Client: '',

          'Position Name': '',

          'Total Contact': team.TC ?? 0,

          'Call back': team.CB ?? 0,

          'Not Interested': team.NI ?? 0,

          'Not Relevant': team.NR ?? 0,

          'Profile Shared': team.PS ?? 0,

          'Success %': this.teamSuccess(team),

          Total: this.teamGrandTotal(team),

        })

      })

      return rows

    },

    downloadReport() {

      if (!this.canDownloadReport || !this.isDownloadReady) return



      const filename = this.getDownloadFilename()

      const rows = this.buildRecruiterExportRows()



      if (rows.length > 0) {

        exportRowsToExcel(rows, filename, 'Recruiter Work Tracker')

        return

      }



      if (this.downloadFile) {

        downloadBase64Excel(this.downloadFile, filename)

      }

    },

    getReport() {

      this.compiledData = []

      this.hasFetched = false

      this.downloadFile = ''



      if (this.startDate === '' || this.endDate === '') {

        this.reportStatus = 'Please select start and end dates.'

        return

      }



      this.loading = true

      this.reportStatus = ''



      const todayStr = moment().locale('en').format('YYYY-MM-DD')

      if (new Date(this.startDate) <= new Date(todayStr) && new Date(this.startDate) <= new Date(this.endDate)) {

        reportService.getRecTracker(this.startDate, this.endDate, this.userData.emp_id).then(res => {

          this.hasFetched = true

          if (res.status === 'OK') {

            this.reportStatus = ''

            this.compiledData = Array.isArray(res.data) ? res.data : []

            this.filename = res.filename || ''

            this.downloadFile = res.file || ''

            if (!this.compiledData.length) {

              this.reportStatus = 'No data found for selected dates.'

            }

          } else if (res.status === 401 || res.status === 403) {

            window.sessionStorage.setItem('lastPage', window.location.href.split('/#')[1])

            this.reportStatus = 'Session expired. Redirecting to login…'

            localStorage.clear()

            this.$router.push({ name: 'auth-login' })

          } else if (res.status === 400) {

            this.reportStatus = 'No data found for selected dates.'

            this.compiledData = []

          } else if (res.status === 500) {

            this.reportStatus = `Error: ${(res.data && res.data.message) || 'Server error.'} Kindly contact IT admin.`

            this.compiledData = []

          } else if (res.status === 504) {

            this.reportStatus = `Error: ${(res.data && res.data.message) || 'Connection timeout.'} Kindly contact admin.`

            this.compiledData = []

          }

          this.loading = false

        }).catch(() => {

          this.hasFetched = true

          this.loading = false

          this.reportStatus = 'Failed to load report. Please try again.'

          this.compiledData = []

        })

      } else if (new Date(this.startDate) > new Date(this.endDate)) {

        this.loading = false

        this.hasFetched = true

        this.reportStatus = 'Start date cannot be greater than end date.'

      } else {

        this.loading = false

        this.hasFetched = true

        this.reportStatus = 'Start date cannot be greater than today.'

      }

    },

  },

}

</script>



<style lang="scss">

@import '@core/scss/vue/libs/vue-flatpicker.scss';

</style>



<style scoped>

.work-tracker-block {

  margin: 0.75rem 0.5rem 1.25rem;

}



.team-header {

  text-align: center;

  padding: 0.5rem 0.75rem;

  background-color: #00ac99;

  color: #fff;

  font-weight: 600;

  font-size: 0.9375rem;

  border: 1px solid #5e5873;

  border-bottom: none;

}



.table-scroll {

  overflow-x: auto;

}



.work-tracker-table {

  width: 100%;

  border-collapse: collapse;

  font-size: 0.9375rem;

  background-color: #fff;

}



.work-tracker-table th,

.work-tracker-table td {

  border: 1px solid #5e5873;

  padding: 0.45rem 0.5rem;

  vertical-align: middle;

}



.work-tracker-table thead th {

  background-color: #e1fffd;

  color: #5e5873;

  font-weight: 600;

  text-align: center;

  white-space: nowrap;

}



.work-tracker-table tbody td {

  background-color: #fff;

  color: #5e5873;

}



.work-tracker-table tfoot td {

  background-color: #e1fffd;

  color: #5e5873;

  font-weight: 600;

}



.work-tracker-table .footer-label {

  text-align: center;

}



.work-tracker-table .col-recruiter {

  width: 11%;

  min-width: 90px;

}



.work-tracker-table .col-client {

  width: 14%;

  min-width: 100px;

}



.work-tracker-table .col-position {

  width: 18%;

  min-width: 140px;

}



.work-tracker-table .col-num {

  width: 8%;

  min-width: 72px;

  text-align: center;

}



.work-tracker-table .col-total {

  width: 7%;

  min-width: 56px;

}



.work-tracker-table .text-left {

  text-align: left;

}



.work-tracker-table .text-center {

  text-align: center;

}

</style>


